function humanizeTechnicalKey(key) {
  return String(key || "")
    .replace(/\./g, " · ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Rótulo amigável para feature_kind ou source_key de consumo de IA.
 * @param {"feature" | "source"} kind
 * @param {string} key
 * @param {(key: string, opts?: object) => string} t
 */
export function getAiCreditAuditLabel(kind, key, t) {
  const k = String(key || "").trim();
  if (!k) return "—";

  return t(`platformPage.usageMetricAudit.${kind}.${k}`, {
    defaultValue: t(`platformPage.aiCreditAudit.${kind}.${k}`, {
      defaultValue: humanizeTechnicalKey(k),
    }),
  });
}
